module.exports = __webpack_public_path__ + "img/rejected.302d9c68.svg";